/* Hound Dog Gaming: deck and set tool.
   Looks cards up in live store inventory through two small JSON views of the theme
   (search.hdg-json and collection.hdg-json), then adds what is in stock to the cart. */
(function () {
  var root = document.querySelector('[data-hdg-deck]');
  var cfgEl = document.getElementById('hdg-deck-config');
  if (!root || !cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var el = function (tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
  var norm = function (s) {
    return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u2018\u2019]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase();
  };
  var gameByKey = function (key) { return cfg.games.filter(function (g) { return g.key === key; })[0] || cfg.games[0]; };

  /* ---------- tabs ---------- */
  var tabs = $$('[data-hdg-deck-tab]');
  var panels = $$('[data-hdg-deck-panel]');
  function showTab(name) {
    tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-hdg-deck-tab') === name ? 'true' : 'false'); });
    panels.forEach(function (p) { p.hidden = p.getAttribute('data-hdg-deck-panel') !== name; });
  }
  tabs.forEach(function (t) { t.addEventListener('click', function () { showTab(t.getAttribute('data-hdg-deck-tab')); }); });

  /* ---------- parsing a pasted list ---------- */
  var HEADER = /^(deck|main ?deck|sideboard|side|commander|companion|maybeboard|pok[eé]mon|trainers?|energy|lands?|creatures?|spells?|total cards)\b[^0-9]*:?\s*\d*\s*$/i;
  function parseList(text, game) {
    var out = [], index = {};
    String(text || '').split(/\r?\n/).forEach(function (raw) {
      var line = raw.replace(/^\s*SB:\s*/i, '').trim();
      if (!line || /^(\/\/|#)/.test(line) || HEADER.test(line)) return;
      var qty = 1, name = line, num = null;
      var m = line.match(/^(\d+)\s*x?\s+(.+)$/i);
      if (m) { qty = parseInt(m[1], 10); name = m[2].trim(); }
      if (game.numbered) {
        // Pokémon TCG Live format: "4 Charizard ex OBF 125"
        var p = name.match(/^(.*?)\s+([A-Z][A-Za-z0-9-]{1,5})\s+(\d{1,3})$/);
        if (p) { name = p[1].trim(); num = parseInt(p[3], 10); }
        else { var n = name.match(/^(.*?)\s+(\d{1,3})\s*\/\s*\d{1,3}$/); if (n) { name = n[1].trim(); num = parseInt(n[2], 10); } }
      } else {
        // Magic exports: "1 Sol Ring (C21) 263 *F*"
        name = name.replace(/\s+[\(\[][A-Za-z0-9]{2,6}[\)\]].*$/, '').replace(/\s+\*.*$/, '').replace(/\s+#\d+.*$/, '').trim();
      }
      if (!name || qty < 1) return;
      var key = norm(name) + '|' + (num || '');
      if (index[key]) index[key].qty += qty;
      else { index[key] = { qty: qty, name: name, num: num }; out.push(index[key]); }
    });
    return out;
  }

  /* ---------- inventory lookup ---------- */
  var cache = {};
  var STOP = ['a', 'an', 'and', 'at', 'by', 'for', 'from', 'in', 'of', 'on', 'the', 'to', 'with'];
  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); });
  }
  function searchName(name) {
    var words = name.split(/\s+/).map(function (w) { return w.replace(/[",:()\[\]]/g, ''); }).filter(Boolean);
    // The store search drops common short words, and a title: filter on one of them matches nothing.
    var useful = words.filter(function (w) { return STOP.indexOf(w.toLowerCase()) === -1; });
    if (useful.length) words = useful;
    var q = words.map(function (w) { return 'title:' + w; }).join(' AND ');
    var key = norm(q);
    if (cache[key]) return cache[key];
    var base = cfg.searchUrl + '?view=hdg-json&type=product&q=' + encodeURIComponent(q);
    cache[key] = fetchJson(base).then(function (first) {
      if (first.pages > 1) {
        return fetchJson(base + '&page=2').then(function (second) { return first.products.concat(second.products); }, function () { return first.products; });
      }
      return first.products;
    });
    return cache[key];
  }

  // Does this listing's title start with the card name, followed by something that looks like set details?
  function titleMatches(product, entry) {
    var title = norm(product.t), name = norm(entry.name);
    if (title === name) return true;
    if (title.indexOf(name + ' ') !== 0) return false;
    var rest = product.t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').slice(entry.name.length).trim();
    if (/^[\(\[\-\d]/.test(rest)) return true;                     // "(Master Ball Pattern)", "[Professor Elm]", "071/063", "- 123"
    if (/^[A-Z0-9]{2,6}(\s|$)/.test(rest)) return true;            // set code such as "C21" or "TSR"
    if (product.ve && norm(rest).indexOf(norm(product.ve)) === 0) return true;  // set name spelled out
    // Set name without its code: vendor "SV01: Scarlet & Violet Base Set", title "... Scarlet & Violet Base Set 196/198"
    var setName = product.ve ? product.ve.replace(/^[^:]{1,12}:\s*/, '') : '';
    if (setName && norm(rest).indexOf(norm(setName)) === 0) return true;
    return false;
  }
  function numberMatches(product, entry) {
    if (!entry.num) return true;
    var re = new RegExp('(^|[^0-9])0*' + entry.num + '\\s*/');
    return re.test(product.t);
  }
  function inGame(product, game) {
    var tags = (product.tg || []).map(norm);
    return game.tags.every(function (t) { return tags.indexOf(norm(t)) !== -1; });
  }
  function stockOf(v) {
    if (!v.a) return 0;
    return (v.m && v.pol === 'deny') ? Math.max(0, v.q) : 99;
  }

  function resolve(entry, game) {
    return searchName(entry.name).then(function (products) {
      var options = [];
      products.forEach(function (p) {
        if (!inGame(p, game) || !titleMatches(p, entry) || !numberMatches(p, entry)) return;
        p.v.forEach(function (v) { var s = stockOf(v); if (s > 0) options.push({ id: v.id, price: v.p, stock: s, title: p.t, url: p.u.split('?')[0], img: p.img }); });
      });
      options.sort(function (a, b) { return a.price - b.price; });
      var need = entry.qty, picks = [];
      options.forEach(function (o) {
        if (need <= 0) return;
        var take = Math.min(need, o.stock);
        picks.push({ id: o.id, qty: take, price: o.price, title: o.title, url: o.url });
        need -= take;
      });
      return { entry: entry, picks: picks, have: entry.qty - need };
    }, function () { return { entry: entry, picks: [], have: 0, failed: true }; });
  }

  function runAll(entries, game, onProgress) {
    var results = new Array(entries.length), next = 0, done = 0;
    return new Promise(function (resolveAll) {
      if (!entries.length) return resolveAll(results);
      function worker() {
        if (next >= entries.length) return;
        var i = next++;
        resolve(entries[i], game).then(function (r) {
          results[i] = r; done++; onProgress(done, entries.length);
          if (done === entries.length) resolveAll(results); else worker();
        });
      }
      for (var w = 0; w < Math.min(4, entries.length); w++) worker();
    });
  }

  /* ---------- cart ---------- */
  function addToCart(items, statusEl, button) {
    if (!items.length) return;
    var merged = {};
    items.forEach(function (i) { merged[i.id] = (merged[i.id] || 0) + i.qty; });
    var payload = Object.keys(merged).map(function (id) { return { id: Number(id), quantity: merged[id] }; });
    button.disabled = true;
    statusEl.className = 'hdg-deck__status'; statusEl.textContent = 'Adding to cart…';
    fetch(cfg.cartAddUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: payload }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        button.disabled = false;
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Some cards could not be added.');
        var count = payload.reduce(function (n, p) { return n + p.quantity; }, 0);
        statusEl.className = 'hdg-deck__status is-ok';
        statusEl.textContent = '';
        statusEl.appendChild(document.createTextNode(count + (count === 1 ? ' card' : ' cards') + ' added. '));
        var link = el('a', null, 'View cart'); link.href = cfg.cartUrl; statusEl.appendChild(link);
      })
      .catch(function (err) {
        button.disabled = false;
        statusEl.className = 'hdg-deck__status is-err';
        statusEl.textContent = err.message + ' Check your cart; some of these may already be in it or have sold.';
      });
  }

  /* ---------- list results ---------- */
  var listInput = $('[data-hdg-deck-input]');
  var listGame = $('[data-hdg-deck-game]');
  var listOut = $('[data-hdg-deck-results]');
  var checkBtn = $('[data-hdg-deck-check]');

  function renderResults(results, game) {
    listOut.innerHTML = '';
    var wanted = 0, have = 0, cost = 0, missing = [];
    results.forEach(function (r) { wanted += r.entry.qty; have += r.have; r.picks.forEach(function (p) { cost += p.qty * p.price; }); if (r.have < r.entry.qty) missing.push((r.entry.qty - r.have) + ' ' + r.entry.name); });

    var summary = el('div', 'hdg-deck__summary');
    var big = el('div', 'hdg-deck__big');
    big.appendChild(el('b', null, have + ' of ' + wanted));
    big.appendChild(el('span', 'hdg-label', 'cards in stock'));
    summary.appendChild(big);
    var track = el('div', 'hdg-freeship__track'); var fill = el('span'); fill.style.width = (wanted ? Math.round(have / wanted * 100) : 0) + '%'; track.appendChild(fill); summary.appendChild(track);
    var actions = el('div', 'hdg-deck__actions');
    var addBtn = el('button', 'hdg-btn', 'Add ' + have + ' to cart · ' + money(cost)); addBtn.type = 'button'; addBtn.disabled = have === 0;
    var status = el('p', 'hdg-deck__status'); status.setAttribute('role', 'status');
    actions.appendChild(addBtn); actions.appendChild(status); summary.appendChild(actions);
    listOut.appendChild(summary);

    var table = el('table', 'hdg-deck__table');
    table.innerHTML = '<thead><tr><th scope="col">Card</th><th scope="col">In stock</th><th scope="col">Our listing</th><th scope="col">Price</th></tr></thead>';
    var tbody = el('tbody');
    results.forEach(function (r) {
      var tr = el('tr', r.have === 0 ? 'is-missing' : (r.have < r.entry.qty ? 'is-partial' : ''));
      tr.appendChild(el('td', 'hdg-deck__name', r.entry.qty + ' × ' + r.entry.name + (r.entry.num ? ' #' + r.entry.num : '')));
      tr.appendChild(el('td', 'hdg-deck__have', r.have + ' / ' + r.entry.qty));
      var listing = el('td', 'hdg-deck__listing');
      if (r.picks.length) {
        r.picks.forEach(function (p) { var a = el('a', null, (p.qty > 1 ? p.qty + ' × ' : '') + p.title); a.href = p.url; a.target = '_blank'; a.rel = 'noopener'; listing.appendChild(a); });
      } else listing.textContent = r.failed ? 'Could not check' : 'Not in stock';
      tr.appendChild(listing);
      var line = r.picks.reduce(function (n, p) { return n + p.qty * p.price; }, 0);
      tr.appendChild(el('td', 'hdg-deck__price', r.picks.length ? money(line) : '—'));
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    var scroller = el('div', 'hdg-deck__scroll'); scroller.appendChild(table); listOut.appendChild(scroller);

    addBtn.addEventListener('click', function () {
      var items = []; results.forEach(function (r) { r.picks.forEach(function (p) { items.push({ id: p.id, qty: p.qty }); }); });
      addToCart(items, status, addBtn);
    });

    // Offer to pass the missing cards on as a want list.
    var want = $('[data-hdg-deck-want]');
    if (want) {
      want.hidden = missing.length === 0;
      var body = $('[data-hdg-deck-want-body]', want);
      if (body) body.value = 'Want list (' + game.label + '), not in stock when checked:\n' + missing.join('\n');
      var count = $('[data-hdg-deck-want-count]', want);
      if (count) count.textContent = missing.length + (missing.length === 1 ? ' card' : ' cards');
    }
    listOut.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function checkList() {
    var game = gameByKey(listGame.value);
    var entries = parseList(listInput.value, game);
    if (!entries.length) { listOut.innerHTML = ''; listOut.appendChild(el('p', 'hdg-deck__status is-err', 'Paste a list first, one card per line, for example "4 Lightning Bolt".')); return; }
    if (entries.length > cfg.maxLines) entries = entries.slice(0, cfg.maxLines);
    checkBtn.disabled = true;
    listOut.innerHTML = '';
    var progress = el('p', 'hdg-deck__status', 'Checking stock… 0 of ' + entries.length);
    listOut.appendChild(progress);
    runAll(entries, game, function (done, total) { progress.textContent = 'Checking stock… ' + done + ' of ' + total; })
      .then(function (results) { checkBtn.disabled = false; renderResults(results, game); });
  }
  if (checkBtn) checkBtn.addEventListener('click', checkList);

  /* ---------- popular decks ---------- */
  $$('[data-hdg-deck-preset]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var deck = cfg.decks[Number(btn.getAttribute('data-hdg-deck-preset'))];
      if (!deck) return;
      listGame.value = deck.game;
      listInput.value = deck.list;
      showTab('list');
      checkList();
    });
  });

  /* ---------- complete a set ---------- */
  var setGame = $('[data-hdg-set-game]');
  var setPick = $('[data-hdg-set-pick]');
  var setNeed = $('[data-hdg-set-need]');
  var setOut = $('[data-hdg-set-results]');
  var setCards = [];
  var setMode = 'master';

  function fillSets() {
    var game = gameByKey(setGame.value);
    setPick.innerHTML = '';
    var first = el('option', null, 'Choose a set'); first.value = ''; setPick.appendChild(first);
    game.sets.forEach(function (s) { var o = el('option', null, s.n); o.value = s.h; setPick.appendChild(o); });
    setOut.innerHTML = ''; setCards = [];
  }

  function parseNeed(text) {
    var set = {}, any = false;
    String(text || '').split(/[\s,;]+/).forEach(function (part) {
      var range = part.match(/^(\d{1,3})-(\d{1,3})$/);
      if (range) { for (var i = parseInt(range[1], 10); i <= parseInt(range[2], 10); i++) { set[i] = true; any = true; } }
      else if (/^\d{1,3}$/.test(part)) { set[parseInt(part, 10)] = true; any = true; }
    });
    return any ? set : null;
  }

  function renderSet() {
    setOut.innerHTML = '';
    if (!setCards.length) { setOut.appendChild(el('p', 'hdg-deck__status', 'Nothing in stock from this set right now.')); return; }
    var need = parseNeed(setNeed.value);
    var shown = need ? setCards.filter(function (c) { return c.num && need[c.num]; }) : setCards;
    var numbers = {}; setCards.forEach(function (c) { if (c.num) numbers[c.num] = true; });
    var size = setCards.reduce(function (n, c) { return Math.max(n, c.of || 0); }, 0);

    // A master set wants every printing of a number (normal, holofoil, reverse holo, ball patterns);
    // a basic set wants one copy of each number. The key decides what counts as "the same card".
    var master = setMode === 'master';
    var keyOf = function (c) { return (c.num || c.title) + (master ? '|' + norm(c.print) : ''); };
    var printings = {}; setCards.forEach(function (c) { printings[(c.num || c.title) + '|' + norm(c.print)] = true; });

    var summary = el('div', 'hdg-deck__summary');
    var modes = el('div', 'hdg-tabs'); modes.setAttribute('role', 'group'); modes.setAttribute('aria-label', 'What are you collecting?');
    [['master', 'Master set: every printing'], ['single', 'One of each number']].forEach(function (m) {
      var b = el('button', null, m[1]); b.type = 'button'; b.setAttribute('aria-pressed', setMode === m[0] ? 'true' : 'false');
      b.addEventListener('click', function () { if (setMode !== m[0]) { setMode = m[0]; renderSet(); } });
      modes.appendChild(b);
    });
    summary.appendChild(modes);
    var big = el('div', 'hdg-deck__big');
    big.appendChild(el('b', null, String(Object.keys(numbers).length) + (size ? ' of ' + size : '')));
    big.appendChild(el('span', 'hdg-label', (size ? 'card numbers in stock' : 'cards in stock') + ' · ' + Object.keys(printings).length + ' printings'));
    summary.appendChild(big);
    var each = master ? 'each printing' : 'each number';
    if (need) summary.appendChild(el('p', 'hdg-deck__note', shown.length + ' of our listings match the numbers you entered. The cheapest copy of ' + each + ' is ticked.'));
    var actions = el('div', 'hdg-deck__actions');
    var allLabel = master ? 'Select every printing' : 'Select one of each';
    var all = el('button', 'hdg-btn hdg-btn--ghost', allLabel); all.type = 'button';
    var addBtn = el('button', 'hdg-btn', 'Add selected to cart'); addBtn.type = 'button'; addBtn.disabled = true;
    var status = el('p', 'hdg-deck__status'); status.setAttribute('role', 'status');
    actions.appendChild(all); actions.appendChild(addBtn); actions.appendChild(status); summary.appendChild(actions);
    setOut.appendChild(summary);

    var list = el('div', 'hdg-set__grid');
    // The list is sorted by number, then price, so the first listing seen for a key is the cheapest copy.
    var first = {};
    shown.forEach(function (c, i) {
      var key = keyOf(c);
      var row = el('label', 'hdg-set__card');
      var box = el('input'); box.type = 'checkbox'; box.id = 'hdg-set-card-' + i; box.setAttribute('data-id', c.id); box.setAttribute('data-price', c.price);
      if (!first[key]) { first[key] = true; box.setAttribute('data-first', '1'); box.checked = !!need; }
      row.appendChild(box);
      if (c.img) { var img = el('img'); img.src = c.img; img.alt = ''; img.loading = 'lazy'; row.appendChild(img); }
      var info = el('span', 'hdg-set__info');
      var tag = [c.num ? '#' + c.num + (c.of ? '/' + c.of : '') : '', c.print, c.cond].filter(Boolean).join(' · ');
      info.appendChild(el('span', 'hdg-label', tag));
      var a = el('a', null, c.title); a.href = c.url; a.target = '_blank'; a.rel = 'noopener'; info.appendChild(a);
      row.appendChild(info);
      row.appendChild(el('span', 'hdg-set__price', money(c.price)));
      list.appendChild(row);
    });
    setOut.appendChild(list);

    function refresh() {
      var n = 0, cost = 0;
      $$('input[type=checkbox]', list).forEach(function (b) { if (b.checked) { n++; cost += Number(b.getAttribute('data-price')); } });
      addBtn.disabled = n === 0;
      addBtn.textContent = n ? 'Add ' + n + ' to cart · ' + money(cost) : 'Add selected to cart';
    }
    list.addEventListener('change', refresh);
    all.addEventListener('click', function () {
      var boxes = $$('input[type=checkbox]', list); var on = !boxes.some(function (b) { return b.checked; });
      boxes.forEach(function (b) { b.checked = on && b.getAttribute('data-first') === '1'; });
      all.textContent = on ? 'Clear selection' : allLabel; refresh();
    });
    addBtn.addEventListener('click', function () {
      var items = $$('input[type=checkbox]', list).filter(function (b) { return b.checked; }).map(function (b) { return { id: b.getAttribute('data-id'), qty: 1 }; });
      addToCart(items, status, addBtn);
    });
    refresh();
  }

  function loadSet() {
    var game = gameByKey(setGame.value), handle = setPick.value;
    setOut.innerHTML = ''; setCards = [];
    if (!handle) return;
    var status = el('p', 'hdg-deck__status', 'Loading what we have from this set…'); setOut.appendChild(status);
    var base = game.collectionUrl + '/' + handle + '?view=hdg-json';
    fetchJson(base).then(function (first) {
      var pages = [];
      for (var p = 2; p <= Math.min(first.pages, 8); p++) pages.push(fetchJson(base + '&page=' + p));
      return Promise.all(pages).then(function (rest) { return rest.reduce(function (all, r) { return all.concat(r.products); }, first.products); });
    }).then(function (products) {
      products.forEach(function (p) {
        var m = p.t.match(/(\d{1,3})\s*\/\s*(\d{1,3})/);
        // Printing comes from the variant ("Near Mint / English / Holofoil") plus any pattern named in the title.
        var pattern = (p.t.match(/master ball|pok[eé] ?ball|mirror foil|reverse holo(?:foil)?/i) || [''])[0];
        p.v.forEach(function (v) {
          if (stockOf(v) <= 0) return;
          var parts = String(v.n || '').split(' / ');
          var printing = parts.length >= 3 ? parts[2] : '';
          var print = [printing];
          if (pattern && norm(printing).indexOf(norm(pattern).replace('foil', '')) === -1) print.push(pattern.replace(/\b\w/g, function (ch) { return ch.toUpperCase(); }));
          setCards.push({ id: v.id, price: v.p, title: p.t, url: p.u.split('?')[0], img: p.img, num: m ? parseInt(m[1], 10) : null, of: m ? parseInt(m[2], 10) : null, print: print.filter(Boolean).join(' '), cond: parts.length >= 3 ? parts[0] : '' });
        });
      });
      setCards.sort(function (a, b) { return (a.num || 9999) - (b.num || 9999) || a.price - b.price; });
      renderSet();
    }).catch(function () { setOut.innerHTML = ''; setOut.appendChild(el('p', 'hdg-deck__status is-err', 'Could not load this set. Try again in a moment.')); });
  }

  if (setGame) {
    setGame.addEventListener('change', fillSets);
    setPick.addEventListener('change', loadSet);
    var needTimer;
    setNeed.addEventListener('input', function () { clearTimeout(needTimer); needTimer = setTimeout(function () { if (setCards.length) renderSet(); }, 300); });
    fillSets();
  }

  showTab(location.hash === '#sets' ? 'sets' : (location.hash === '#decks' ? 'decks' : 'list'));
  root.hidden = false;
})();
